import { SyntheticEvent, memo, useCallback, useRef, useState } from 'react';
import { SettingsType, VideoType } from '../../../../constants/enums';
// import { hexRGBA } from '../../../../utilities/colors'

import type { CSSProperties } from '@linaria/core';
import { cx } from '@linaria/core';
import { openMenuDialog } from '../../../../actions/menu';
import { goToNotes } from '../../../../actions/nav';
import locales from '../../../../locales/en';
import { getAnimationsEnabledfromUeopt } from '../../../../mfcLogic/settings';
import { TransitionTypes } from '../../../../state';
import { openRoom, pinRoom, setLoungeSurrogate } from '../../../../state/state.rooms';
import { isTouchDevice } from '../../../../utilities/browser';
import { motionTransition } from '../../../../utilities/transitions';
import ButtonModelMenu from '../../../Buttons/ButtonModelMenu';
import { useDragHelper } from '../../../Hooks/useDragHelper';
import { useGridCenteredIndexAppState } from '../../../Hooks/useGridCenteredIndexAppState';
import { useFloatingPreviewSelector } from '../../../Hooks/useModal';
import { useIsRoomPinned } from '../../../Hooks/useRoom';
import { useSettingSelector } from '../../../Hooks/useSettings';
import { useUserSelector } from '../../../Hooks/useUser';
import { useVideoPlaying } from '../../../Hooks/useVideo';
import RoomIcon from '../../../Icons/Room';
import IconViewers from '../../../Icons/Viewers';
import BadgeAvatar from '../../../common/BadgeAvatar';
import LiveSnapStream from '../../LiveSnapStream';
import BookmarkBadge from '../Badges/Bookmark';
import FriendBadge from '../Badges/Friend';
import { NewAndMissMFCBadges } from '../Badges/NewAndMissMFC';
import PopularBadge from '../Badges/Popular';
import PriorMissMFCBadge from '../Badges/PriorMissMFC';
import RecommendationBadge from '../Badges/Recommendation';
import TrendingBadge from '../Badges/Trending';
import GroupShowBanner from '../Banners/GroupShow';
import MissMFCBanner from '../Banners/MissMFC';
import NewModelBanner from '../Banners/NewModel';
import PopularBanner from '../Banners/Popular';
import TrendingBanner from '../Banners/Trending';
import NotesButton from '../Buttons/NotesButton';
import PinButton from '../Buttons/PinButton';
import Container from '../Container';
import LargeFloatingPreview from '../LargeFloatingPreview';
import ModelName from '../ModelName';
import { VideoCover } from '../VideoCover';
import { GetStylesConfig, getAnonymousMissMFCRank, isAnonymousMissMFC, resolveDisplayHighlight } from '../helpers';
import "./Preview.linaria.module.css!=!./Preview?./Preview.linaria.module.css?css=H4sIAAAAAAAAA41Va8+sJhD+3l9h0jR5T1reipfVtT+GoICyIiigrkv63xvXy6rJyeknfRhmnplhLt/YNghrBPM2UnXxfYaOCfoEhGtaWK5kVijRN/Kff39732tqVAVN87i5Vhn+vqCpwJYPdLtyNwja58gH4Qg3rcBTNpvcxDRAkNRxx7GrKC8rmw1YfwGwgB/btbFDY17eeelegEtCn1kAoyRKw1uUHJwxVo5p+nEG50aJ3u7OVAhWN/XoX2fksOClBNzSxmQFlZbqTUOGiJOWlZHTb+/8TWDrTWBV+zkuOxRQ1sX2jFyDdcklyJW1qlljPJ3toZYvBHHT3Mr0AjcbgjJ7tjCf7Po3vjm2ku2+sW6TvE3s54NAdGQizt3ADc+54HbK3r+CHnQf4b2554suCNvnIROraM7EURIyBKkM4sC6XGlCdQbbp2eU4MRbAshxUZda9ZLs/gcEwZrjHr4u0H0ug0IJpbOf2ogfCCrTqWBYiYHGhPcmg77/xx72hPSrtzpwIye2Wq29/4+PMVWRn7MzOj1F8Am4SBEME8oewQU6pqQFhr/oSrPjnaoKERRJHmJ9gRvZnN1Dcodpj3Hx/xhbyRFMoX9LilX7VDDHPPFgtFF0SdPtQ5P4KGCCh77L1ROYChM1rsYEnqgGStL1eDdbGwTjoRtH7dRANRNqzCpOCN0Hh5rauxgR7Otexsz7blgxmPUDBk6oAnjAFmuQY1LSpegKLIqvhXoVztYFnpZEesCby+tPz/+O6aef0nKgIUZBH7Vp+mumOcu/IvrbCzzgBe1zJ4HQ6F4OCBL90Op/sGgsjcCWZr4H4s+7zR3DGt3G5GcdU/GyEvMo+st7G2mxpvLQ/QnKa+qH9faiczxXG0TjkWpA+OyZ3nVZcRqPH+gevbGcTaBQ0lJpLzMSPxD02SB57BgXluqMaNWuRfF1rBVeKLkVy4/DyDz2WHfpsXWKHbqs8hGcokgJdoGbyjKqo0NfGpTKEAb5GS1dOS57J1eC7EUvUH9LGDRuGTS/M8Y+O4SaPiz7EzhtkPfKpJIc/b1D9uqSCzz7exrpelt//wGMYCkunwcAAA=="
const rootStyles = "atm_ar_1bp4okc atm_mk_h2mmj6 atm_9s_1txwivl";
const previewContainerStyles = "atm_mk_h2mmj6 atm_e2_1dk5qia";
const actionContainerStyles = "atm_wq_wbg9ig atm_ar_1bp4okc atm_mk_stnw88 atm_h_1h6ojuz atm_9s_1txwivl atm_n3_idpfg4 atm_tk_idpfg4";
const stylesBadgeContainer = "atm_wq_wbg9ig atm_gq_2efq5t atm_gz_1amm6g8 atm_ar_1bp4okc atm_mk_stnw88 atm_h_1h6ojuz atm_9s_1txwivl atm_6i_idpfg4 atm_fq_idpfg4";
// const stylesModelMenu = css`
//     z-index: ${PAPER_HEIGHTS.highest};
//     visibility: hidden;
//     position: absolute;
//     bottom: 3px;
//     right: 3px;
// `

const stylesModelMenuVisibility = "atm_vl_ewfl5b";
const stylesAvatarNotesContainer = "atm_wq_wbg9ig atm_mk_stnw88 atm_fq_j39m9b atm_tk_j39m9b";
const stylesPinBigPreviewContainer = "atm_9s_1txwivl";
const stylesAvatarContainer = "atm_3f_1en252t atm_2d_1kiau1z atm_5j_1osqo2v atm_9s_1txwivl";
const stylesPriorMissMFCBadgeClass = "atm_e2_1dk5qia atm_vy_rzutr2 atm_gz_yh40bf";
const stylesNewAndMissMFCBadges = "atm_c8_137efj2 atm_h3_1l7b3ar atm_vy_1osqo2v";
const stylesMissMFCBanner = "atm_c8_137efj2 atm_e2_1dk5qia";
const stylesMargin = "atm_gi_181067c";
const stylesHeightAndFontSize = "atm_c8_137efj2 atm_e2_1dk5qia";
const stylesLiveSnapStream = "atm_5j_i2wt44 atm_70_2fli30 atm_ks_15vqwwr";
const stylesLiveSnapStreamBesideAvatar = "atm_oyp9lw_1ukun5f atm_8gve3a_2u4p88 atm_11srunv_1drjro";
const stylesLiveSnapStreamHighlight = "atm_3f_1fmrp5d";
const stylesDisplayBadges = "atm_9s_1txwivl";
const stylesModelNameBorderTop = "atm_67_bke03k";
const stylesModelNameCenter = "atm_fc_1h6ojuz";
const stylesViewerContainer = "atm_aj_10fvni5 atm_h_1h6ojuz atm_gq_yh40bf atm_h0_1y44olf atm_cs_8n312b atm_9s_1txwivl atm_7l_u67f1s";
const stylesViewerCounter = "atm_c8_137efj2 atm_gz_yh40bf";
const badgeContainerStyles = "atm_gq_2efq5t atm_wq_wbg9ig atm_ar_1bp4okc atm_h_esu3gu atm_mk_stnw88 atm_9s_1txwivl";
const badgeCornerBottomRight = "atm_h0_191fzq7 atm_n3_idpfg4 atm_6i_idpfg4";
interface PreviewProps {
  activeRoom?: number;
  columnWidth: number;
  disableMenuNextPrev?: boolean;
  displayBookmarkBadge?: boolean;
  displayBookmarkHighlight?: boolean;
  displayFriendBadge?: boolean;
  displayFriendHighlight?: boolean;
  displayGroupShowBanner?: boolean;
  displayHeight: number;
  displayMissMFCBadge?: boolean;
  displayMissMFCBanner?: boolean;
  displayNewModelBadge?: boolean;
  displayNewModelBanner?: boolean;
  displayNoteIconButton?: boolean;
  displayPopularBadge?: boolean;
  displayPopularBanner?: boolean;
  displayPopularHighlight?: boolean;
  displayRecentlyVisitedBadge?: boolean;
  displayRecentlyVisitedHighlight?: boolean;
  displayRecommendationBadge?: boolean;
  displayRecommendationHighlight?: boolean;
  displayTrendingBadge?: boolean;
  displayTrendingBanner?: boolean;
  displayTrendingHighlight?: boolean;
  enableCenteredIndexTracking?: boolean;
  enableLargePreview?: boolean;
  enablePin?: boolean;
  enablePinToTopSymbols?: boolean;
  getStyle: (key: string, config?: GetStylesConfig) => any;
  id: number;
  index: number;
  loungeSlug?: string;
  name: string;
  passiveMode?: boolean;
  singlePin?: boolean;
  pinLimitReached?: boolean;
  slug: string;
}
const Preview = memo((props: PreviewProps) => {
  const {
    enableCenteredIndexTracking,
    displayRecentlyVisitedHighlight,
    displayRecentlyVisitedBadge,
    displayRecommendationBadge,
    displayRecommendationHighlight,
    displayTrendingHighlight,
    displayBookmarkHighlight,
    displayPopularHighlight,
    displayFriendHighlight,
    displayGroupShowBanner,
    displayTrendingBanner,
    displayNewModelBanner,
    displayPopularBanner,
    displayMissMFCBanner,
    displayBookmarkBadge,
    displayTrendingBadge,
    displayNewModelBadge,
    displayPopularBadge,
    displayMissMFCBadge,
    displayFriendBadge,
    displayNoteIconButton,
    enablePinToTopSymbols,
    disableMenuNextPrev,
    enableLargePreview,
    pinLimitReached,
    displayHeight,
    passiveMode,
    columnWidth,
    activeRoom,
    loungeSlug,
    singlePin,
    enablePin,
    getStyle,
    index,
    slug,
    name,
    id
  } = props;
  const isGridCenteredOnIndex = useGridCenteredIndexAppState(index, enableCenteredIndexTracking);
  const isVideoAlreadyPlaying = useVideoPlaying(id);
  const shouldForceVideoPlay = isGridCenteredOnIndex && !isVideoAlreadyPlaying;
  const ref = useRef(null);
  const snapRef = useRef<HTMLImageElement>(undefined);
  const {
    dragStart,
    dragMove,
    dragEnd
  } = useDragHelper(id, snapRef);
  const [showVideoPreview, setVideoPreview] = useState(false);
  const [sort] = useSettingSelector(SettingsType.DEFAULT, 'sort');
  const [animatePreviews] = useSettingSelector(SettingsType.DEFAULT, 'animatePreviews');
  const staticImage = !getAnimationsEnabledfromUeopt(animatePreviews);
  const [overlayAvatarHomepage = 1] = useSettingSelector(SettingsType.DEFAULT, 'overlayAvatarHomepage');
  const isAvatarOverlayEnabled = overlayAvatarHomepage === 1;
  const isPinnedToTopRecentlyVisited = useUserSelector(id, 'isPinnedToTopRecentlyVisited');
  const isPinnedToTopTrending = useUserSelector(id, 'isPinnedToTopTrending');
  const isPinnedToTopPopular = useUserSelector(id, 'isPinnedToTopPopular');
  const isPinnedToTopMissMFC = useUserSelector(id, 'isPinnedToTopMissMFC');
  const isBanned = useUserSelector(id, 'banned');
  const isGroupShowPending = useUserSelector(id, 'isGroupShowPending');
  const priorMissMfcRank = useUserSelector(id, 'priorMissMfcRank');
  const groupShowRoomCount = useUserSelector(id, 'groupShowRoomCount');
  const isBroadcasting = useUserSelector(id, 'isBroadcasting');
  const isTrendingNew = useUserSelector(id, 'isTrendingNew');
  const isRecommended = useUserSelector(id, 'isPinnedToTopModelYouMayLike');
  const isTruePrivate = useUserSelector(id, 'isTruePrivate');
  const isPrivateShow = useUserSelector(id, 'isPrivateShow');
  const isPublicShow = useUserSelector(id, 'isPublicShow');
  const trendingDiff = useUserSelector(id, 'trendingDiff');
  const missMFCPrize = useUserSelector(id, 'missMFCPrize');
  const isAnonymous = isAnonymousMissMFC(id);
  const missMFCRankFromSelector = useUserSelector(id, 'missMFCRank');
  const missMFCRank = isAnonymous ? getAnonymousMissMFCRank(slug) : missMFCRankFromSelector;
  const isMissMFCFromSelector = useUserSelector(id, 'isMissMFC');
  const isMissMFC = isAnonymous ? true : isMissMFCFromSelector;
  const isGroupShow = useUserSelector(id, 'isGroupShow');
  const isBookmark = useUserSelector(id, 'isBookmark');
  const isNewModel = useUserSelector(id, 'isNewModel');
  const isClubShow = useUserSelector(id, 'isClubShow');
  const isPopular = useUserSelector(id, 'isPopular');
  const isOffline = useUserSelector(id, 'isOffline');
  const isNGVideo = useUserSelector(id, 'isNGVideo');
  const isLounge = useUserSelector(id, 'isLounge');
  const isKicked = useUserSelector(id, 'isKicked');
  const isFriend = useUserSelector(id, 'isFriend');
  const creation = useUserSelector(id, 'creation');
  const viewers = useUserSelector(id, 'viewers');
  const channel = useUserSelector(id, 'channel');
  const isModel = useUserSelector(id, 'isModel');
  const hasNote = useUserSelector(id, 'hasNote');
  const server = useUserSelector(id, 'server');
  const isAway = useUserSelector(id, 'isAway');
  const phase = useUserSelector(id, 'phase');
  const color = useUserSelector(id, 'color');
  const isRoomPinned = useIsRoomPinned(id);
  const isPreviewPinned = useFloatingPreviewSelector(id, 'close');
  const inHiddenShow = isTruePrivate || isPrivateShow || isGroupShow || isClubShow;
  const noShowType = isOffline || inHiddenShow || isAway;
  const isViewable = !noShowType && !isBanned && !isKicked;
  const showSinglePin = singlePin && isViewable;

  // const stylesBannerPX = getStyle('banner', { px: true })
  // const stylesNamePX = getStyle('name', { px: true })
  const stylesName = getStyle('name');
  const stylesBanner = getStyle('banner');
  const stylesBannerPopular = stylesBanner('popular');
  const stylesBannerPopularViewers = stylesBannerPopular('viewers');
  const stylesBannerTrending = stylesBanner('trending');
  const stylesBannerTrendingDiff = stylesBannerTrending('diff');
  const stylesBannerNew = stylesBanner('new');
  const stylesBannerNewTime = stylesBannerNew('time');
  const stylesBannerMissMFC = stylesBanner('missMFC');
  const stylesBannerMissMFCRank = stylesBannerMissMFC('rank');
  const stylesUtilities = getStyle('utilities');
  const stylesBadge = getStyle('badge');
  const stylesBadgeStatus = stylesBadge('status');
  const stylesBadgeNewMissMFC = stylesBadge('newMissMFC');
  const stylesPriorMissMFCBadge = stylesBadge('priorMissMFC');
  const stylesMaxWidth = getStyle('column')('maxWidth');
  const stylesAvatar = getStyle('avatar');
  const stylesViewers = getStyle('viewers');

  // if (!id) {
  //     return <AvatarSkeleton width={width} height={height} />
  // }

  // const modelColor = useModelColor(color)

  //
  // For testing purposes:
  //
  // const candisplayFriendBadge = true
  // const canDisplayBookmarkBadge = true
  // const canDisplayTrendingBadge = true
  // const canDisplayPopularBadge = true
  // const canDisplayNewModelBadge = true
  // const canDisplayMissMFCBadge = true
  // const canDisplayPriorMissMFCBadge = true
  // const canDisplayRecentlyVisitedBadge = true
  // const canDisplayNotesButton = true
  // const canEnablePinToTopSymbols = false

  //
  // Symbols
  //
  const canEnablePinToTopSymbols = enablePinToTopSymbols;

  //
  // Buttons
  //
  const canDisplayNotesButton = hasNote && displayNoteIconButton;
  const canDisplayLargePreviewButton = enableLargePreview && isPublicShow && !isAnonymous;
  const canDisplayPinButton = (enablePin && !pinLimitReached || isRoomPinned || showSinglePin) && !isAnonymous && isViewable;

  //
  // Banners
  //
  const canDisplayGroupShowBanner = displayGroupShowBanner && (isGroupShow || isGroupShowPending || groupShowRoomCount);
  const canDisplayTrendingBanner = displayTrendingBanner && isTrendingNew && trendingDiff;
  const canDisplayNewModelBanner = displayNewModelBanner && isNewModel;
  const canDisplayPopularBanner = displayPopularBanner && isPopular && viewers;
  const canDisplayMissMFCBanner = displayMissMFCBanner && isMissMFC && missMFCRank;

  //
  // Badges
  //
  const candisplayFriendBadge = displayFriendBadge && isFriend;
  const canDisplayBookmarkBadge = displayBookmarkBadge && isBookmark;
  const canDisplayTrendingBadge = displayTrendingBadge && (!canEnablePinToTopSymbols || isPinnedToTopTrending) && isTrendingNew && trendingDiff;
  const canDisplayPopularBadge = displayPopularBadge && (!canEnablePinToTopSymbols || isPinnedToTopPopular) && isPopular && viewers;
  const canDisplayNewModelBadge = displayNewModelBadge && isNewModel;
  const canDisplayMissMFCBadge = displayMissMFCBadge && (!canEnablePinToTopSymbols || isPinnedToTopMissMFC || sort === 'miss_mfc') && isMissMFC && missMFCRank > 0;
  const canDisplayPriorMissMFCBadge = !!priorMissMfcRank;
  const canDisplayRecentlyVisitedBadge = displayRecentlyVisitedBadge && (!canEnablePinToTopSymbols || isPinnedToTopRecentlyVisited);
  const canDisplayRecommendationBadge = displayRecommendationBadge && (!canEnablePinToTopSymbols || isRecommended);
  const canDisplayRecommendationHighlight = displayRecommendationHighlight && isRecommended && (!canEnablePinToTopSymbols || isRecommended);

  // Highlights
  const canDisplayActiveRoomHighlight = activeRoom === id;
  const canDisplayFriendHighlight = displayFriendHighlight && isFriend;
  const canDisplayBookmarkHighlight = displayBookmarkHighlight && isBookmark;
  const canDisplayPopularHighlight = displayPopularHighlight && isPopular && (!canEnablePinToTopSymbols || isPinnedToTopPopular);
  const canDisplayTrendingHighlight = displayTrendingHighlight && isTrendingNew && (!canEnablePinToTopSymbols || isPinnedToTopTrending);
  const canDisplayRecentlyViewedHighlight = displayRecentlyVisitedHighlight && (!canEnablePinToTopSymbols || isPinnedToTopRecentlyVisited);
  const highlight = resolveDisplayHighlight({
    displayRecentlyVisitedHighlight: canDisplayRecentlyViewedHighlight,
    displayActiveRoomHighlight: canDisplayActiveRoomHighlight,
    displayTrendingHighlight: canDisplayTrendingHighlight,
    displayBookmarkHighlight: canDisplayBookmarkHighlight,
    displayPopularHighlight: canDisplayPopularHighlight,
    displayFriendHighlight: canDisplayFriendHighlight,
    displayRecommendationHighlight: canDisplayRecommendationHighlight
  });
  const canDisplayBanners = canDisplayGroupShowBanner || canDisplayTrendingBanner || canDisplayNewModelBanner || canDisplayMissMFCBanner || canDisplayPopularBanner;
  const canDisplayBadges = canDisplayPriorMissMFCBadge || canDisplayNewModelBadge || canDisplayBookmarkBadge || canDisplayTrendingBadge || canDisplayMissMFCBadge || canDisplayPopularBadge || candisplayFriendBadge || canDisplayRecommendationBadge;
  const onPinCallback = useCallback((event: SyntheticEvent) => {
    event.stopPropagation();
    motionTransition(() => pinRoom(id, {
      pinned: !isRoomPinned
    }), {
      id,
      skipTransition: isRoomPinned,
      // skip if we're unpinning it
      transitionSource: TransitionTypes.TILE,
      transitionDestination: TransitionTypes.PINROOM
    });
  }, [id, isRoomPinned]);
  const onOpenMenuCallback = useCallback((event: SyntheticEvent) => {
    event.stopPropagation();
    openMenuDialog(slug, {
      hideNextPrev: disableMenuNextPrev,
      transitionSource: TransitionTypes.TILE
    });
  }, [slug, disableMenuNextPrev]);
  const onOpenContextMenuCallback = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (isAnonymous) return;
    onOpenMenuCallback(event);
    return false;
  }, [isAnonymous, onOpenMenuCallback]);
  const onGoToRoomCallback = useCallback((event: SyntheticEvent) => {
    event.stopPropagation();
    if (isAnonymous) return;
    if (loungeSlug) {
      // if we're in the lounge, set the surrogate
      setLoungeSurrogate(id, loungeSlug);
    } else {
      openRoom(slug, {
        transitionSource: TransitionTypes.TILE
      });
    }
  }, [isAnonymous, id, slug, loungeSlug]);
  const onOpenNote = useCallback((event: SyntheticEvent) => {
    event.stopPropagation();
    goToNotes(name);
  }, [id, name]);
  const shouldDisplayLargePreviewButton = canDisplayLargePreviewButton && (showVideoPreview || isTouchDevice || isPreviewPinned);
  const shouldDisplayPinButton = canDisplayPinButton && (showVideoPreview || isTouchDevice || isRoomPinned);
  const canShowMenu = !isAnonymous && (showVideoPreview || isTouchDevice);
  const canShowViewers = !!viewers && !canDisplayPopularBanner;
  return <div data-testid="Container__ModelDisplay" ref={ref} key={id} id={`tile-${id}`} className={rootStyles}>
            <div data-testid="Container__Preview" className={previewContainerStyles} style={{
      '--height': `${displayHeight}px`
    } as CSSProperties} onMouseOver={isTouchDevice ? null : () => setVideoPreview(true)} onMouseLeave={isTouchDevice ? null : () => setVideoPreview(false)} onContextMenu={onOpenContextMenuCallback} onClick={onGoToRoomCallback} onDragStart={dragStart} onDragEnd={dragEnd} onDrag={dragMove} draggable>
                <VideoCover />
                <LiveSnapStream suppressVideo={passiveMode || !showVideoPreview && !shouldForceVideoPlay} style={{
        ...(highlight && {
          '--highlight': highlight
        }),
        ...(isAvatarOverlayEnabled && {
          '--avatar-overlay-size': stylesAvatar('size') + 'px'
        })
      } as CSSProperties} className={cx(stylesLiveSnapStream, highlight && stylesLiveSnapStreamHighlight, isAvatarOverlayEnabled && stylesLiveSnapStreamBesideAvatar)}
      // onPreviewLoaded={onLoad}
      isBroadcasting={isBroadcasting} compact={stylesMaxWidth < 150} videoID={VideoType.ModelTile} isTruePrivate={isTruePrivate} isPrivateShow={isPrivateShow} isGroupShow={isGroupShow} isAnonymous={isAnonymous} staticImage={staticImage} isClubShow={isClubShow} height={displayHeight} isOffline={isOffline} isNGVideo={isNGVideo} width={columnWidth} isLounge={isLounge} isModel={isModel} channel={channel} server={server} isAway={isAway} banned={isBanned} phase={phase} noBackground hideControls videoMuted id={id} />
                <div className={stylesAvatarNotesContainer}>
                    {isAvatarOverlayEnabled && <div className={stylesAvatarContainer}>
                            <BadgeAvatar size={stylesAvatar('size')} onClick={onOpenMenuCallback} disableBadge addBoxShadow alt={name} id={id} />
                        </div>}
                    {canDisplayNotesButton && <NotesButton size={stylesUtilities('iconSize')} tooltipPlacement={'bottom'} onClick={onOpenNote} title="Open Notes" shadow filled />}
                </div>
                {(shouldDisplayPinButton || canDisplayRecentlyVisitedBadge) && <div className={actionContainerStyles}>
                        <div className={stylesPinBigPreviewContainer}>
                            {shouldDisplayLargePreviewButton && <LargeFloatingPreview size={stylesUtilities('iconSize')} id={id} />}
                            {shouldDisplayPinButton && <PinButton title={(isRoomPinned ? 'Unpin' : 'Pin') + ' Model'} size={stylesUtilities('iconSize')} filled={isRoomPinned} onClick={onPinCallback} />}
                        </div>
                        {canDisplayRecentlyVisitedBadge && <Container style={{
          '--margin': (shouldDisplayPinButton ? getStyle('roomIconOffset') || 8 : 8) + 'px'
        }} className={stylesMargin} tooltipPlacement="bottom" title="Recently Visited" shadow>
                                <RoomIcon size={stylesUtilities('iconSize')} color="#fff" filled />
                            </Container>}
                    </div>}
                {canDisplayBadges && <div style={{
        '--margin-bottom': stylesBadgeStatus('offsetY') + 'px',
        '--margin-left': stylesBadgeStatus('offsetX') + 'px'
      } as CSSProperties} className={stylesBadgeContainer}>
                        <div className={stylesDisplayBadges}>
                            {candisplayFriendBadge && <FriendBadge size={stylesBadgeStatus('iconSize')} />}
                            {canDisplayBookmarkBadge && <BookmarkBadge size={stylesBadgeStatus('iconSize')} />}
                            {canDisplayRecommendationBadge && <RecommendationBadge size={stylesBadgeStatus('iconSize')} />}
                            {canDisplayPopularBadge && <PopularBadge size={stylesBadgeStatus('iconSize')} />}
                            {canDisplayTrendingBadge && <TrendingBadge size={stylesBadgeStatus('iconSize')} />}
                            {canDisplayPriorMissMFCBadge && <PriorMissMFCBadge className={stylesPriorMissMFCBadgeClass} priorMissMfcRank={priorMissMfcRank} style={{
            '--height': stylesPriorMissMFCBadge('height') + 'px',
            '--width': stylesPriorMissMFCBadge('width') + 'px'
          }} />}
                        </div>
                        {(canDisplayMissMFCBadge || canDisplayNewModelBadge) && <NewAndMissMFCBadges className={stylesNewAndMissMFCBadges} style={{
          '--font-size': stylesBadgeNewMissMFC('fontSize') + 'px'
        } as CSSProperties} showMissMFC={canDisplayMissMFCBadge} showNew={canDisplayNewModelBadge} missMFCRank={missMFCRank} />}
                    </div>}
                {(canShowViewers || canShowMenu) && <div style={{
        '--margin-bottom': stylesBadgeStatus('offsetY') + 'px',
        '--margin-right': stylesBadgeStatus('offsetX') + 'px'
      } as CSSProperties} className={cx(badgeContainerStyles, badgeCornerBottomRight)}>
                        {canShowViewers && <div className={stylesViewerContainer}>
                                <IconViewers title={locales.modelTile.viewers} size={stylesViewers('iconSize')} color="#fff" styles={{
            '--margin-bottom': stylesViewers('offsetY') + 'px'
          } as CSSProperties} />
                                <span style={{
            '--font-size': stylesViewers('fontSize') + 'px'
          } as CSSProperties} className={stylesViewerCounter}>
                                    {viewers}
                                </span>
                            </div>}
                        {canShowMenu && <ButtonModelMenu className={cx(
        // stylesModelMenu,
        !isAnonymous && (showVideoPreview || isTouchDevice) && stylesModelMenuVisibility)} onClick={onOpenMenuCallback} />}
                    </div>}
                {/* <div
                    className={cx(
                        stylesModelMenu,
                        !isAnonymous &&
                            (showVideoPreview || isTouchDevice) &&
                            stylesModelMenuVisibility,
                    )}
                 >
                    <ButtonModelMenu onClick={onOpenMenuCallback} />
                 </div> */}
            </div>
            {canDisplayBanners && <>
                    {canDisplayMissMFCBanner && <MissMFCBanner className={stylesMissMFCBanner} style={{
        '--font-size': stylesBanner('fontSize') + 'px',
        '--height': stylesBanner('height') + 'px'
      }} rankClassName={stylesMargin} rankStyle={{
        '--margin': stylesBannerMissMFCRank('margin')
      }} missMFCPrize={missMFCPrize} missMFCRank={missMFCRank} />}
                    {canDisplayTrendingBanner && <TrendingBanner className={stylesHeightAndFontSize} style={{
        '--font-size': stylesBanner('fontSize') + 'px',
        '--height': stylesBanner('height') + 'px'
      }} diffClassName={stylesMargin} diffStyle={{
        '--margin': stylesBannerTrendingDiff('margin')
      }} text={stylesBannerTrending('text')} diff={trendingDiff} />}
                    {canDisplayPopularBanner && <PopularBanner className={stylesHeightAndFontSize} style={{
        '--font-size': stylesBanner('fontSize') + 'px',
        '--height': stylesBanner('height') + 'px'
      }} viewersClassName={stylesMargin} viewersStyle={{
        '--margin': stylesBannerPopularViewers('margin')
      }} iconSize={stylesBanner('iconSize')} text={stylesBannerPopular('text')} viewers={viewers} />}
                    {canDisplayGroupShowBanner && (isGroupShow || isGroupShowPending || groupShowRoomCount) && <GroupShowBanner className={stylesHeightAndFontSize} style={{
        '--font-size': stylesBanner('fontSize') + 'px',
        '--height': stylesBanner('height') + 'px'
      }} iconSize={stylesBanner('iconSize')} roomCount={groupShowRoomCount} isLive={isGroupShow} />}
                    {canDisplayNewModelBanner && <NewModelBanner className={stylesHeightAndFontSize} style={{
        '--font-size': stylesBanner('fontSize') + 'px',
        '--height': stylesBanner('height') + 'px'
      }} timeClassName={stylesMargin} timeStyle={{
        '--margin': stylesBannerNewTime('margin')
      }} compact={columnWidth < 135} creation={creation} />}
                </>}
            <ModelName modelId={id} onClick={onGoToRoomCallback} className={cx(stylesHeightAndFontSize, canDisplayBanners && stylesModelNameBorderTop, (canDisplayBanners || stylesName('center')) && stylesModelNameCenter)} style={{
      '--font-size': stylesName('fontSize')() + 'px',
      '--height': stylesName('height') + 'px'
    }} isAnonymous={isAnonymous} color={color} name={name} />
        </div>;
});
export default Preview;
export { Preview };